import React, { FC, useContext } from 'react'
import { QuizContext } from '../../../contexts/quizProvider'
import QuizResult from '../QuizResult/QuizResult'
import QuizCardPicture from '../QuizCardPicture/QuizCardPicture'
import css from './QuizQuestion.module.scss'
import MaxWidth from '../../layout/MaxWidth/MaxWidth'
import cx from 'classnames'
import { IQuestion } from '../../types'
import Loader from '../../common/Loader/Loader'

const QuizQuestion: FC<{
  setIsQuizOpen: React.Dispatch<React.SetStateAction<boolean>>
}> = ({ setIsQuizOpen }) => {
  const { step, final, q1, q2, q3, q4, loading } = useContext(QuizContext)

  const getQuestion = (): IQuestion => {
    switch (step) {
      case 1:
        return q1
      case 2:
        return q2
      case 3:
        return q3
      case 4:
        return q4
    }
  }

  return (
    <div className={cx(css.wrapper, loading && css.wrapperLoading)}>
      {loading ? (
        <Loader />
      ) : (
        <>
          {final ? (
            <QuizResult setIsQuizOpen={setIsQuizOpen} />
          ) : (
            <MaxWidth>
              <ul
                className={cx(
                  css.list,
                  final ? null : css['items-' + getQuestion().variants.length],
                )}
              >
                {getQuestion().variants.map((variant, index) => (
                  <QuizCardPicture key={index} variant={variant} />
                ))}
              </ul>
            </MaxWidth>
          )}
        </>
      )}
    </div>
  )
}

export default QuizQuestion
